import { ref, type Ref } from 'vue';

export const unreadNotificationCount: Ref<number> = ref(0);
